import { h } from 'preact';
import { formatMoney } from 'utils/storefront/format-resource';
import formatProductTitle from 'utils/formatProductTitle';
import Image from 'utils/image';
import { MONOGRAM_PROPERTIES } from 'utils/constants';
import { withCartContext } from './cart-context';

const CartItem = (props) => {
  const { cart, line } = props;
  const lineTitle = formatProductTitle(
    line.product_title,
    line.options_with_values,
  );

  const isFinalSale = Boolean(
    line.properties && line.properties['_tag_:final-sale'],
  );

  const monogramProperties = () => {
    if (!line.properties) return null;

    const monogramLineItemProperties = Object.entries(line.properties)
      .filter((prop) => MONOGRAM_PROPERTIES.includes(prop[0]))
      .map((prop) => prop[1]);
    return (
      <div className="body-2 mt-5">
        {monogramLineItemProperties.map((part, index) => (
          <span key={index}>
            <span className="body-2">{part}</span>
            <span className="px-2 leading-none">
              {index !== monogramLineItemProperties.length - 1 && ' | '}
            </span>
          </span>
        ))}
      </div>
    );
  };

  const compareAtPrice = parseInt(line.properties?._compare_at_price, 10);
  const hasCompareAtPrice = !Number.isNaN(compareAtPrice) && compareAtPrice > 0;
  const originalPrice = line.original_line_price / 100;
  const hasDiscount = line?.line_level_total_discount > 0;

  const showRedFinalPrice = Boolean(hasCompareAtPrice || hasDiscount);

  const DropShip = Boolean(
    line.properties && line.properties['_tag_:drop-ship'],
  );

  return (
    line && (
      <div
        className="flex gap-5 lg:mb-5"
        key={line.key}
        {...(DropShip ? { 'data-dropship-product': '' } : {})}
      >
        <div className="aspect[2/3] w-[120px] md:w-1/3 lg:w-[120px]">
          <Image
            {...line?.merchandise?.product?.featuredImage}
            src={
              line?.featured_image?.url ||
              line?.merchandise?.product?.featuredImage?.url
            }
          />
        </div>
        <div>
          <div className="flex justify-between gap-3">
            <span className="h7--medium text-text-default">
              {line?.merchandise?.product?.vendor || line?.vendor}
            </span>
            <p className="flex gap-1">
              {hasDiscount && (
                <del className="inline-block body-3 text-text-disabled line-through">
                  {formatMoney(
                    line?.cost?.compareAtAmountPerQuantity ||
                      (line?.line_level_total_discount && {
                        amount: originalPrice,
                      }),
                  )}
                </del>
              )}
              {hasCompareAtPrice && !hasDiscount && (
                <span className="md:text-sm text-text-disabled mr-2 product-price--strike-through !text-12 font-GTAmerica md:!text-14 leading-160">
                  {formatMoney({
                    amount: compareAtPrice * line.quantity,
                  })}
                </span>
              )}

              <span
                className={`body-3 font-GTAmerica ${
                  showRedFinalPrice ? 'text-sale' : 'text-text-subdued'
                }`}
              >
                {formatMoney({
                  amount:
                    line.vendor === 'DailyKarma'
                      ? line.final_line_price / 100
                      : line.final_price / 100,
                })}
              </span>
            </p>
          </div>
          <p className="mb-2.5">
            <a
              href={`${Shopify.routes.root}products/${
                cart.mode === 'storefront'
                  ? // eslint-disable-next-line max-len
                    `${Shopify.routes.root}products/${line.merchandise.product.handle}`
                  : line.url
              }`}
              className="no-underline body-3 text-text-default"
            >
              {cart.mode === 'storefront'
                ? line.merchandise?.product.title
                : lineTitle}
            </a>
          </p>
          {isFinalSale && (
            <p className="h8 mb-2.5">
              <span className="text-sale">
                {window.TMW.Strings.product.finalSaleCart}
              </span>
            </p>
          )}
          {line?.options_with_values.map((item, index) => (
            <p key={index} className="mb-0.5 body-3 text-text-default">
              {item.name}: {item.value}
            </p>
          ))}
          <p className="body-3 text-text-default mb-0.5">
            {window.TMW.Strings.cart.quantity}: {line.quantity}
          </p>
          {monogramProperties()}
        </div>
      </div>
    )
  );
};

export default withCartContext(CartItem);
